export class Quotation {
    id: string;
    title: string;
    sum: string;
    discount: string;
    total: string;
    date: Date;
    status: string;
    description: string;
    constructor() {
        this.id = '';
        this.title = '';
        this.sum = '';
        this.discount = '';
        this.total = '';
        this.date = new Date();
        this.status = '';
        this.description = '';
    }
}
